export default "__VITE_ASSET__BNeROWJT__"